import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useAchievementsContext } from '../../../../contexts/AchievementsContext/AchievementsContext';
import { AchievementsModalGamePass } from '../AchievementsModalGamePass/AchievementsModalGamePass';
import { useAchievementsModalContext } from '../context/AchievementsModalContext';
import { useAchievementModalHotkeys } from './useAchievementModalHotkeys';

export function AchievementModalHeader() {
  const { handleAchievementCreate } = useAchievementModalHotkeys();
  const { isLoading } = useAchievementsContext();
  const { readOnly } = useAchievementsModalContext();

  return (
    <Modal.Header>
      <Modal.Title className="d-flex align-items-end">
        Achievements
        <div className="ml-3">
          <Button
            size="sm"
            variant="secondary"
            onClick={handleAchievementCreate}
            title="Ctrl(Cmd)+Shift+A"
            disabled={isLoading || readOnly}
          >
            + Add
          </Button>
        </div>
        <AchievementsModalGamePass disabled={readOnly} />
      </Modal.Title>
    </Modal.Header>
  );
}
